import JiraIcon from './customIcons/Jira'
import SubprocessIcon from './customIcons/Subprocess'
import TaskIcon from './customIcons/TaskIcon'
import ChangeShapeIcon from './customIcons/ChangeShapeIcon'
import DecisionIcon from './customIcons/DecisionIcon'
import ConnectionIcon from './customIcons/ConnectionIcon'
import OrganisationIcon from './customIcons/OrganisationIcon'
import ProjectIcon from './customIcons/ProjectIcon'
import SubworkflowIcon from './customIcons/SubworkflowIcon'
import WorkflowIcon from './customIcons/WorkflowIcon'
import { CARD_COLORS, EVENT_COLORS } from '@/shared/constants/colorPalette'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles'
import { mdi } from 'vuetify/iconsets/mdi'
import { h } from 'vue'

const customSvgNameTocomponent = {
  JiraIcon,
  SubprocessIcon,
  TaskIcon,
  ChangeShapeIcon,
  DecisionIcon,
  ConnectionIcon,
  OrganisationIcon,
  ProjectIcon,
  SubworkflowIcon,
  WorkflowIcon
}

const customSvgs = {
  component: (props) => h(customSvgNameTocomponent[props.icon])
}

const buildPaletteColors = (colors, variant) => {
  const result = {}
  for (const c of colors) {
    result[c.name] = c[variant]
  }
  return result
}

const paletteLight = {
  ...buildPaletteColors(CARD_COLORS, 'light'),
  ...buildPaletteColors(EVENT_COLORS, 'light')
}

const paletteDark = {
  ...buildPaletteColors(CARD_COLORS, 'dark'),
  ...buildPaletteColors(EVENT_COLORS, 'dark')
}

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: localStorage.getItem('qlerify-theme-resolved') || 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          background: '#F1F2F2',
          surface: '#FCFCFC',
          primary: '#022A44',
          secondary: '#229AD6',
          accent: '#C5539F',
          info: '#229AD6',
          error: '#FF5252',
          ...paletteLight
        }
      },
      dark: {
        dark: true,
        colors: {
          background: '#121518',
          surface: '#1E2228',
          primary: '#4DA8E8',
          secondary: '#5BC0F5',
          accent: '#D87FC5',
          info: '#5BC0F5',
          error: '#FF7777',
          ...paletteDark
        }
      }
    }
  },
  icons: {
    defaultSet: 'mdi',
    sets: {
      mdi,
      mds: {
        component: (props) => {
          const iconName = props.icon.replace('mds:', '').replaceAll('-', '_')
          return <span class="material-symbols-outlined">{iconName}</span>
        }
      },
      custom: customSvgs
    }
  }
})
